<form [formGroup]="form" (submit)="submitForm()">
  <mat-card class="p-4 w-7 mx-auto bg-grey-button form-home-school-registration-information">
    <div class="edit-field my-1">
      <label for="studentName">Student Name</label>
      <input
        id="studentName"
        matInput
        formControlName="studentName"
        aria-readonly="true"
        data-pw="edit_student_name_input"
        data-qa="edit_student_name_input" />
    </div>

    <div class="edit-field my-1">
      <label for="studentPID">Student PID</label>
      <input
        id="studenPID"
        matInput
        formControlName="studentPid"
        placeholder="Student PID"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_student_pid_input"
        data-qa="edit_student_pid_input" />
    </div>

    <div class="edit-field my-1">
      <label for="homeschool-number">Homeschool ID Number *</label>
      <input
        id="homeschool-number"
        matInput
        formControlName="homeschoolId"
        maxlength="50"
        placeholder="Homeschool ID Number"
        [readonly]="viewMode === 'readonly'"
        [attr.aria-readonly]="viewMode === 'readonly'"
        data-pw="edit_homeschool_id_input"
        data-qa="edit_homeschool_id_input" />
      <cfi-form-inline-error  [control]="form.get('homeschoolId')" />
    </div>

    <div class="edit-field my-1">
      <label for="homeschool-name">Homeschool Name *</label>
      <input
        id="homeschool-name"
        matInput
        formControlName="homeschoolName"
        maxlength="250"
        placeholder="Homeschool Name"
        [readonly]="viewMode === 'readonly'"
        [attr.aria-readonly]="viewMode === 'readonly'"
        data-pw="edit_homeschool_name_input"
        data-qa="edit_homeschool_name_input" />
      <cfi-form-inline-error  [control]="form.get('homeschoolName')" />
    </div>

    <div class="edit-field my-1">
      <label for="homeschool-administrator-name">Homeschool Administrator Name *</label>
      <input
        id="homeschool-administrator-name"
        matInput
        formControlName="administratorName"
        maxlength="250"
        placeholder="Administrator Name"
        [readonly]="viewMode === 'readonly'"
        [attr.aria-readonly]="viewMode === 'readonly'"
        data-pw="edit_homeschool_administrator_name_input"
        data-qa="edit_homeschool_administrator_name_input" />
      <cfi-form-inline-error  [control]="form.get('administratorName')" />
    </div>

    <div class="edit-field my-1">
      <lib-county-selector
        formControlName="county"
        stateCode="nc"
        label="Homeschool County"
        [required]="true"
        [readonly]="viewMode === 'readonly'"
        dataPw="edit_homeschool_county_input"
        dataQa="edit_homeschool_county_input">
      </lib-county-selector>
      <cfi-form-inline-error [control]="form.get('county')" />
    </div>

    <div class="edit-field my-3">
      <label for="part-time">Will your student attend this homeschool full-time? *</label>
      <mat-slide-toggle
        id="part-time"
        formControlName="isFullTime"
        class="mx-3"
        [attr.aria-readonly]="viewMode === 'readonly'">
        {{ form.get("isFullTime")?.value ? "Yes" : "No" }}
      </mat-slide-toggle>
    </div>
    @if (!form.get("isFullTime")?.value) {
      <div class="edit-field my-1">
        <label for="co-enrollment-type">Co-Enrollment Type *</label>
        <mat-form-field
          appearance="outline">
          <mat-select
            id="co-enrollment-type"
            formControlName="coEnrollmentType"
            data-pw="edit_coenrollment_type_input"
            data-qa="edit_coenrollment_type_input">
            @for (type of coEnrollmentTypes; track type.id) {
              <mat-option [value]="type.name">{{ type.name }} - {{ type.description }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <cfi-form-inline-error  [control]="form.get('coEnrollmentType')" />
      </div>
    }
    @if (!form.disabled) {
      <mat-card-actions align="end" class="mt-5">
        <button
          mat-flat-button
          type="submit"
          [disabled]="!isFormReady()"
          color="primary">Submit
        </button>
      </mat-card-actions>
    }
  </mat-card>
</form>
